<ng-container *ngIf="patient">
  <div class="row" [class.disabled]="disabled" (click)="!disabled ? selectPatient() : null">
    <div class="col"><span class="name">{{ patient.name }}</span><span class="age">{{ getTranslatedAge() }}</span></div>
    <div class="col">{{ patient.species }} ({{ patient.breed || ('patients.patient_list_item.unknown' | translate) }})</div>
  </div>
</ng-container>
